import React, {useEffect, useMemo, useState} from 'react';
import { useSelector } from 'react-redux';
import { cartCurrencySelector, cartTotal } from '../redux/selectors/cartSelector';

function useTotalNumber(productId) {
    const [productTotal, setProductTotal] = useState(null);

    const currency = useSelector(cartCurrencySelector);
    const total = useSelector(state => cartTotal(state, { product_id: productId }));

    const formattedTotal = useMemo(() => {
        if (total === null || total?.total === null || total?.total <= 0) {
            return null;
        } else {
            return `${currency?.sign}${Number(total?.total).toFixed(2)}`;
        }
    }, [total, currency]);

    useEffect(() => {
        setProductTotal(formattedTotal);
    }, [formattedTotal, currency, productId]);

    return productTotal;
}

export default useTotalNumber;
